import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImageSmall = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "-8 -8 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "2.5em",
	height: "2.5em",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M22.5 24H1.5C0.6 24 0 23.4 0 22.5V1.5C0 0.6 0.6 0 1.5 0H22.5C23.4 0 24 0.6 24 1.5V22.5C24 23.4 23.4 24 22.5 24ZM3 21H21V3H3V21Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.5 6C10.4 6 11 6.6 11 7.5C11 8.4 10.4 9 9.5 9C8.6 9 8 8.4 8 7.5C8 6.6 8.6 6 9.5 6Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 18L8 12L11 15L15.5 9L20 18H5Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgImageSmall);
export default ForwardRef;
